/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PlayRoundedSvg from './icon-play-rounded.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PlayRoundedSvg {...validProps} />;
}
SvgComponent.iconName = 'playRounded';

export const PlayRoundedIcon = svgIconWrapper(SvgComponent);
